import { Routes, Route } from "react-router-dom";
import { useState } from "react";
import Navbar from '../src/Navbar/Navbar';
import HeroSection from '../src/HeroSection/HeroSection';
import AboutSection from '../src/AboutSection/AboutSection';
import FeatureSection from '../src/FeatureSection/FeatureSection';
import Courses from '../src/Courses/Courses';
import Offer from '../src/OfferSection/OfferSection';     
import InstructorCarousel from '.././src/InstructorCarousel/InstructorCarousel';
import TestimonialSection from '.././src/TestimonialSection/TestimonialSection';
import ContactSection from '.././src/ContactSection/ContactSection';
import FooterSection from '.././src/FooterSection/FooterSection';
import DirectorMessage from "../src/DirectorMessage/DirectorMessage"; 
import AboutCPIT from "../src/AboutCPIT/AboutCPIT";
import InstructorPage from "../src/InstructorPage/InstructorPage";
import TestimonialPage from "../src/TestimonialPage/TestimonialPage";
import CoursesPage from "../src/CoursesPage/CoursesPage";
import ContactPage from "../src/ContactPage/ContactPage";
import Nielit from "../src/NielitPage/NielitPage";
import ScrollToTop from "../src/Courses/ScrollToTop";
import NotificationPopup from "../src/NotificationPopup.jsx";
import './App.css';
import UpsdmPage from "./UpsdmPage/UpsdmPage";
import BsdmPage from "./BsdmPage/BsdmPage";
import AsdcPage from "./AsdcPage/AsdcPage";
import PmkvyPage from "./PmkvyPage/PmkvyPage";
import CsrPage from "./CsrPage/CsrPage";
import TtscPage from "./TtscPage/TtscPage";
import DdugkyPage from "./DdugkyPage/DdugkyPage";
import NcvtePage from "./NcvtePage/NcvtePage";
import GalleryPage from "./GalleryPage/GalleryPage";
import CovidPage from "./CovidPage/CovidPage";
import SocialWorkPage from "./SocialWorkPage/SocialWorkPage";
import SocialAwarenessPage from "./SocialAwarenessPage/SocialAwarenessPage";
import EnvironmentalAwarenessPage from "./EnvironmentalAwarenessPage/EnvironmentalAwarenessPage";
import HarGharTirangaPage from "./HarGharTirangaPage/HarGharTirangaPage";
import AdcaPage from "./Course/AdcaPage";
import OLevelPage from "./Course/OLevelPage";
import CccPage from "./Course/CccPage";
import TallyPage from "./Course/TallyPage";
import SpokenEnglishPage from "./Course/SpokenEnglishPage";
import DownloadFormPage from "./DownloadFormPage/DownloadFormPage.jsx";
import DonationPage from "./DonationPage/DonationPage.jsx";
import AwardsRecognition from "./AwardsRecognition/AwardsRecognition.jsx";
import LoginModal from "../src/Login/LoginModal.jsx";
import InstituteDashboard from "../src/InstituteDashboard/InstituteDashboard.jsx";
import HRpolicy from "./HRPolicy/HRPolicy.jsx";

function App() {
  const [loginOpen, setLoginOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  
  // Handle successful login
  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    setLoginOpen(false);
  };

  // Handle logout
  const handleLogout = () => {
    setIsLoggedIn(false);
  };
  
  return (
    <div className="App">
      <ScrollToTop />
      
      {/* Pass authentication props to Navbar */}
      <Navbar 
        onLoginClick={() => setLoginOpen(true)}
        isLoggedIn={isLoggedIn}
        onLogout={handleLogout}
      />
      
      <NotificationPopup />
      
      {/* LoginModal with login success handler */}
      <LoginModal
        isOpen={loginOpen}
        onClose={() => setLoginOpen(false)}
        onLoginSuccess={handleLoginSuccess}
      />
      
      <Routes>
        {/* Home Page */}
        <Route 
          path="/" 
          element={
            <>
              <HeroSection/>
              <AboutSection/>
              <Offer/>
              <FeatureSection/>
              <Courses/>
              <InstructorCarousel/>
              <TestimonialSection/>
              <ContactSection/>
            </>
          } 
        />

        {/* Dashboard Route */}
        <Route path="/dashboard" element={<InstituteDashboard />} />

        {/* Other Routes */}
        <Route path="/director-message" element={<DirectorMessage />} />
        <Route path="/about-cpit" element={<AboutCPIT />} />
        <Route path="/instructorPage" element={<InstructorPage />} />
        <Route path="/testimonialPage" element={<TestimonialPage />} /> 
        <Route path="/coursesPage" element={<CoursesPage />} /> 
        <Route path="/contactPage" element={<ContactPage />} />
        <Route path="/nielit" element={<Nielit />} />
        <Route path="/upsdm" element={<UpsdmPage />} />
        <Route path="/bsdm" element={<BsdmPage />} />
        <Route path="/asdc" element={<AsdcPage />} />
        <Route path="/pmkvy" element={<PmkvyPage />} />
        <Route path="/csr" element={<CsrPage />} />
        <Route path="/ddugky" element={<DdugkyPage />} />
        <Route path="/ttsc" element={<TtscPage />} />
        <Route path="/ncvte" element={<NcvtePage />} />
        <Route path="/hrpolicy" element={<HRpolicy/>} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/covid" element={<CovidPage />} />
        <Route path="/socialWork" element={<SocialWorkPage />} />
        <Route path="/socialawareness" element={<SocialAwarenessPage />} />
        <Route path="/environmentalAwareness" element={<EnvironmentalAwarenessPage />} />
        <Route path="/HarGharTiranga" element={<HarGharTirangaPage />} />
        <Route path="/adca" element={<AdcaPage />} />
        <Route path="/olevel" element={<OLevelPage />} />
        <Route path="/ccc" element={<CccPage />} />
        <Route path="/tally" element={<TallyPage />} />
        <Route path="/spoken-english" element={<SpokenEnglishPage />} />
        <Route path="/DownloadForm" element={<DownloadFormPage />} />
        <Route path="/Donation" element={<DonationPage />} />
        <Route path="/AwardsRecognition" element={<AwardsRecognition />} />
      </Routes>

      <FooterSection />

      {/* <HRpolicy/> */}
    </div>
  );
}

export default App;